import cn from "classnames";
import ClipLoader from "react-spinners/ClipLoader";

import { IconButtonProps } from "./IconButtonProps.types";

import styles from "./IconButton.module.scss";

const IconButton = ({
  loading = false,
  icon = null,
  disabled = false,
  size = 24,
  type = "button",
  ...props
}: IconButtonProps) => {
  return (
    <button
      className={cn(styles.button, props.className, {
        [styles.button_disabled]: disabled
      })}
      style={{ width: size, height: size }}
      disabled={disabled || loading}
      type={type}
      {...props}
    >
      {loading ? <ClipLoader size={15} color="#fff" /> : <>{icon}</>}
    </button>
  );
};

export default IconButton;
